var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12l1.8-1.833h14.4L21 12v9.167L19.2 23H4.8L3 21.167V12zm1.8 0v9.167h14.4V12H4.8zm12.6-1.833V6.5a5.552 5.552 0 0 0-1.582-3.89A5.35 5.35 0 0 0 12 1a5.35 5.35 0 0 0-3.818 1.61A5.552 5.552 0 0 0 6.6 6.5v3.667h1.8V6.5c0-.972.38-1.905 1.054-2.593A3.567 3.567 0 0 1 12 2.833c.955 0 1.87.387 2.546 1.074A3.702 3.702 0 0 1 15.6 6.5v3.667h1.8z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessActiveIcon);
export default __webpack_public_path__ + "static/media/accessActiveIcon.60385ab79f637a885e1d9d52d67661ca.svg";
export { ForwardRef as ReactComponent };